/*
 *
 *  * Copyright (c) 2020 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

function _window(): any {
  // return the native window obj
  return window;
}

@Injectable({
  providedIn: 'root'
})
export class WindowRef {
  constructor(@Inject(DOCUMENT) private document) {}

  get nativeWindow(): any {
    return _window();
  }

  get browser(): any {
    return {
      isAndroid: /Android/.test(navigator.userAgent),
      isCordova: !!this.nativeWindow.cordova,
      isEdge: /Edge/.test(navigator.userAgent),
      isFirefox: /Firefox/.test(navigator.userAgent),
      isChrome: /Google Inc/.test(navigator.vendor),
      isChromeIOS: /CriOS/.test(navigator.userAgent),
      isChromiumBased: !!this.nativeWindow.chrome && !/Edge/.test(navigator.userAgent),
      isIE: /Trident/.test(navigator.userAgent),
      isIOS: /(iPhone|iPad|iPod)/.test(navigator.platform),
      isOpera: /OPR/.test(navigator.userAgent),
      isSafari: /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent),
      isTouchScreen:
        'ontouchstart' in this.nativeWindow || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0,
      isWebComponentsSupported:
        'registerElement' in document &&
        'import' in this.document.createElement('link') &&
        'content' in this.document.createElement('template')
    };
  }
}
